import { render, staticRenderFns } from "./WebAppOrder.vue?vue&type=template&id=2802f7d8&scoped=true"
import script from "./WebAppOrder.vue?vue&type=script&lang=js"
export * from "./WebAppOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2802f7d8",
  null
  
)

export default component.exports